import './main.scss';
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../../organisms/header/header';
import RoleRibbon from '../../../organisms/common/role-ribbon/role-ribbon';
import { getAdminMainTabs } from '../../../organisms/common/role-ribbon/role-ribbon.config';
import decodeToken from '../../../../utils/decode-token';
import { canAccessLibrary, canViewUsers } from '../../../../utils/role-utils';
import Library from '../../../organisms/common/library/Library';

const AdminLibrary = () => {
  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (!canAccessLibrary(role)) {
    // Users whose only purpose is the library (translator/reviewer) have no other home when it's disabled
    return <Navigate to={canViewUsers(role) ? '/admin/main' : '/login'} />;
  }

  const topTabs = getAdminMainTabs({ libraryActive: true, role });

  return (
    <div className="App library-page">
      <Header />
      <main>
        <RoleRibbon tabs={topTabs} navigate={navigate} translate={t} />
        <section className="tab-content active">
          <div className="inner">
            <Library />
          </div>
        </section>
      </main>
    </div>
  );
};

export default AdminLibrary;
